import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=f501b838&"
import script from "./BaseModal.vue?vue&type=script&lang=js&"
export * from "./BaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f501b838')) {
      api.createRecord('f501b838', component.options)
    } else {
      api.reload('f501b838', component.options)
    }
    module.hot.accept("./BaseModal.vue?vue&type=template&id=f501b838&", function () {
      api.rerender('f501b838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/BaseModal.vue"
export default component.exports